'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth, useGetProfilePortfolioSnapshot, useWallets } from '@morfi/backend-sdk-v2/client';
import type { JSX } from 'react';
import { getUsdcMint } from '@/config/solana';
import { useActiveNetwork } from '@/lib/network/use-active-network';
import { logger } from '@/lib/telemetry/logger';
import { recordUserPortfolioRealtimeEvidence, useUserPortfolioSnapshotEvidence } from './evidence';
export interface UseUserPortfolioSnapshotQueryOwnerArgs {
  readonly enabled?: boolean;
  readonly knownWallets: readonly string[];
  readonly userId: string;
}
export function useUserPortfolioSnapshotQueryOwner(t0) {
  const $ = _c(10);
  const {
    enabled: t1,
    knownWallets,
    userId
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const t2 = useActiveNetwork();
  let t3;
  if ($[0] !== t2) {
    t3 = getUsdcMint(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const quoteMint = t3;
  let t4;
  if ($[2] !== userId) {
    t4 = {
      userId
    };
    $[2] = userId;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== enabled || $[5] !== knownWallets) {
    t5 = {
      enabled,
      knownWallets,
      logger,
      onEvidence: recordUserPortfolioRealtimeEvidence
    };
    $[4] = enabled;
    $[5] = knownWallets;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const portfolio = useGetProfilePortfolioSnapshot(t4, t5);
  let t6;
  if ($[7] !== portfolio || $[8] !== quoteMint) {
    t6 = {
      ...portfolio,
      quoteMint
    };
    $[7] = portfolio;
    $[8] = quoteMint;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  useUserPortfolioSnapshotEvidence(t6);
}
export function UserPortfolioSnapshotQueryOwner(args) {
  useUserPortfolioSnapshotQueryOwner(args);
  return null;
}
export function ViewerPortfolioSnapshotQueryOwner() {
  const $ = _c(5);
  const {
    isAuthenticated,
    isLoading,
    user
  } = useAuth();
  const {
    wallets
  } = useWallets(isAuthenticated);
  if (isLoading || !isAuthenticated || user === null) {
    return null;
  }
  let t0;
  if ($[0] !== wallets) {
    t0 = wallets.map(_temp);
    $[0] = wallets;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0 || $[3] !== user.id) {
    t1 = <UserPortfolioSnapshotQueryOwner enabled={true} knownWallets={t0} userId={user.id} />;
    $[2] = t0;
    $[3] = user.id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp(wallet) {
  return wallet.address;
}